import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsDefined,
  IsEmail,
  IsNumber,
  IsObject,
  IsOptional,
  MaxLength
} from 'class-validator';
import { PaymentDto } from '../payment.dto';

export class GiftCardCorporateWebCardCreateRequestDto {
  @IsDefined()
  @MaxLength(510)
  fromName: string;

  @IsDefined()
  @MaxLength(255)
  @IsEmail()
  fromEmail: string;

  @IsDefined()
  @MaxLength(255)
  companyPhoneNumber: string;

  @IsDefined()
  @MaxLength(255)
  companyVATNumber: string;

  @IsDefined()
  @MaxLength(255)
  companyName: string;

  @IsDefined()
  companyAddress: {
    buildingNumber?: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    country: string;
    postCode: string;
  };

  @IsNumber()
  quantity: number;

  @IsNumber()
  amount: number;

  @IsNumber()
  merchantId: number;

  @IsBoolean()
  acceptTerms: boolean;

  @IsBoolean()
  acceptsMarketingTerms: boolean;

  @IsNumber()
  @IsOptional()
  giftCardPromotionId?: number;

  @IsBoolean()
  hasIndividualDetails: boolean;

  @IsOptional()
  @IsArray()
  details: {
    customerName: string;
    customerEmail: string;
  }[];

  @IsObject()
  @Type(() => PaymentDto)
  payment: PaymentDto;
}
